import { useEffect, useRef, useState } from "react";
import { usePresence } from "./usePresence";
import PresenceDot, { PRESENCE_STATUS_LABELS } from "./PresenceDot";
import OOOMessageModal from "./OOOMessageModal";
import { whiteArrowDown } from "../../assets/images";
import "./presence.scss";

const SETTABLE_STATUSES = ["Online", "Away", "Busy", "OutOfOffice"];

const PresenceStatusPicker = () => {
    const { status, message, updateStatus } = usePresence();
    const [open, setOpen] = useState(false);
    const [oooModalOpen, setOooModalOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        if (!open) return;
        const handleOutsideClick = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleOutsideClick);
        return () => document.removeEventListener("mousedown", handleOutsideClick);
    }, [open]);

    if (!status) return null;

    return (
        <div className="presenceStatusPicker" ref={ref}>
            <button
                type="button"
                className="presenceStatusPicker-trigger"
                onClick={() => setOpen((prev) => !prev)}
            >
                <PresenceDot status={status} />
                <span className="ms-2">{PRESENCE_STATUS_LABELS[status] ?? status}</span>
                <img
                    src={whiteArrowDown}
                    alt="toggle"
                    className={`presenceStatusPicker-caret ${open ? "open" : ""}`}
                />
            </button>
            {open && (
                <div className="presenceStatusPicker-menu">
                    {SETTABLE_STATUSES.map((option) => (
                        <div
                            key={option}
                            className="presenceStatusPicker-option"
                            onClick={async () => {
                                setOpen(false);
                                if (option === "OutOfOffice") {
                                    setOooModalOpen(true);
                                    return;
                                }
                                await updateStatus(option);
                            }}
                        >
                            <PresenceDot status={option} />
                            <span className="ms-2">{PRESENCE_STATUS_LABELS[option] ?? option}</span>
                        </div>
                    ))}
                </div>
            )}
            <OOOMessageModal
                isOpen={oooModalOpen}
                initialMessage={message}
                toggleModal={() => setOooModalOpen(false)}
                onConfirm={async (oooMessage) => {
                    await updateStatus("OutOfOffice", oooMessage);
                    setOooModalOpen(false);
                }}
            />
        </div>
    );
};

export default PresenceStatusPicker;
